import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export interface Crumb { to: string; label: string }

/** `media`: a picture before the title (a location's cover); on phones it becomes a banner above it. */
export function PageHeader({ crumbs, current, title, sub, actions, titleClass = '', meta, media }: { crumbs?: Crumb[]; current?: string; title: ReactNode; sub?: ReactNode; actions?: ReactNode; titleClass?: string; meta?: ReactNode; media?: ReactNode }) {
  return (
    <>
      {crumbs && crumbs.length > 0 && (
        <nav className="crumbs" aria-label="Jejak">
          {crumbs.map((c) => (
            <span key={c.to}>
              <Link to={c.to}>{c.label}</Link>
              <span aria-hidden="true">/</span>
            </span>
          ))}
          <span aria-current="page">{current ?? (typeof title === 'string' ? title : null)}</span>
        </nav>
      )}
      <header className={`page-head ${media ? 'has-media' : ''}`}>
        {media && <div className="page-head-media">{media}</div>}
        <div className="page-head-text">
          <div className="page-title-row">
            <h1 className={titleClass}>{title}</h1>
            {meta}
          </div>
          {sub && <div className="page-sub">{sub}</div>}
        </div>
        {actions && <div className="page-actions">{actions}</div>}
      </header>
    </>
  );
}
